<form [formGroup]="gerarForm" novalidate>
  <mat-card class="shipping-card">
    <mat-card-header>
      <mat-card-title>Gerar</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col">
          <mat-form-field class="full-width">
            <input matInput placeholder="Competência" formControlName="competencia">
            <mat-error *ngIf="gerarForm.controls['competencia'].hasError('pattern')">
              ex: 2021-01
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field appearance="fill">
            <mat-label>Período</mat-label>
            <mat-date-range-input
              formGroupName="periodo"
              [rangePicker]="periodoPicker">
              <input matStartDate placeholder="Início" formControlName="inicio">
              <input matEndDate placeholder="Fim" formControlName="fim">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="periodoPicker"></mat-datepicker-toggle>
            <mat-date-range-picker #periodoPicker></mat-date-range-picker>
          </mat-form-field>
        </div>
      </div>
      
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="abreModalConfirmacaoGerarRecorrentes()" [disabled]="!gerarForm.valid||this.gerandoFaturas">Gerar Recorrentes</button>
      <button mat-raised-button color="primary" (click)="abreModalConfirmacaoGerarMarcos()" [disabled]="!gerarForm.valid||this.gerandoFaturas">Gerar Marcos</button>
    </mat-card-actions>
  </mat-card>
</form>
<mti-lista-faturas [faturas]="faturas"></mti-lista-faturas>
